import { Component, OnInit, Input } from '@angular/core';
import { Languages, ComponentEvent, StateAwareComponent } from 'src/app/model/rest/base';
import { map } from 'rxjs/operators';
import {Utils} from "../../services/utils/utils";
import {ManagerColV3RestService} from "../../services/rest/v3/manager-col-v3-rest.service";
import * as LessonsV3 from '../../model/v3/lessons';

export class StudentTechnicalProfileFormComponentEvent extends ComponentEvent {
  public static ET_FORM_READONLY = 'readonly';
  public static ET_FORM_EDITABLE = 'editable';

  constructor() {
    super();
  }
  public static formEditable(editable: boolean) {
    const res = new StudentTechnicalProfileFormComponentEvent();
    if (editable) {
      res.eventType = this.ET_FORM_EDITABLE;
    } else {
      res.eventType = this.ET_FORM_READONLY;
    }
    return res;
  }
}

@Component({
    selector: 'app-student-technical-profile-form',
    templateUrl: './student-technical-profile-form.component.html',
    styleUrls: ['./student-technical-profile-form.component.css'],
    standalone: false
})
export class StudentTechnicalProfileFormComponent extends StateAwareComponent<StudentTechnicalProfileFormComponentEvent> implements OnInit {

  _studentId: number;
  _editable = false;
  profile: LessonsV3.PersonalSettings;
  languages = Languages.values;
  _schoolId: number;


  @Input()
  set studentId(studentId: number) {
    this._studentId = studentId;
    this.loadTechnicalProfile();
  }

  @Input()
  set schoolId( schoolId: number) {
    this._schoolId = schoolId;
    this.loadTechnicalProfile();
  }

  callForProfile() {
    return this.managerV3Rest.getStudentTechnicalProfile(this._schoolId, this._studentId);
  }

  loadTechnicalProfile(): any {
    if (!this._studentId || !this._schoolId) {return; }
    this.callForProfile().pipe(
      map(profile => Utils.jsonClone(profile))
    )
    .subscribe( profile => this.setupProfileAfterLoad(profile) );
  }

  set editable(editable: boolean) {
    this._editable = editable;
    this.stateEvent.emit(StudentTechnicalProfileFormComponentEvent.formEditable(editable));
  }

  get editable(): boolean {
    return this._editable;
  }

  saveProfile() {
    return this.managerV3Rest.saveStudentTechnicalProfile(
      this._schoolId,
      this._studentId,
      this.profile
    );
  }

  public onSave() {
    this.editable = false;
    this.saveProfile().subscribe(() => this.loadTechnicalProfile());
  }

  setupProfileAfterLoad(profile: LessonsV3.PersonalSettings) {
    if (profile == null ) {
      this.profile = {
        lang: Languages.English.code,
        phone: '',
        skype: '',
        notifBookingConfirm: false,
        notifOffers: false,
        allowBookingTeacherChange: false,
        introductionState: ''
      };
    } else {
      this.profile = profile;
    }
    this.stateEvent.emit(ComponentEvent.initialized());
  }

  constructor(
    private managerV3Rest: ManagerColV3RestService
  ) {
    super();
   }

  ngOnInit() {
    this.editable = false;
  }
}
